import React, { useState } from 'react';
import { CustomModal } from '../ui';
import { ServiceIcon } from '../../icons';

const BookAServiceInfoModal = ({
  showIcon = false,
  fullWith = false,
  showAsBtn = true,
  disabled = false,
}) => {
  const [openModal, setModalState] = useState(false);
  return (
    <CustomModal
      triggerComponent={showIcon ? <ServiceIcon /> : 'Ραντεβού Service'}
      triggerClass={`${
        showIcon
          ? ''
          : `${
              showAsBtn ? 'btn-secondary text-secondary-button' : 'text-body'
            } ${fullWith && 'w-full'}`
      }`}
      wrapperClass="h-[100vh] lg:h-[30vh] "
      handleClick={setModalState}
      openModal={openModal}
      disabled = {disabled}
    >
      <div className="lg:px-10 px-5 pt-5 lg:pt-[40px] lg:pb-7">
        <div className="flex flex-col items-center gap-6 l:gap-6">
          <h3 className="text-center">Απαιτείται προσθήκη οδηγού</h3>
          Για να προγραμματίσεις ραντεβού για service, θα πρέπει να προσθέσεις τουλάχιστον έναν οδηγό στο αυτοκίνητο.
        </div>
      </div>
    </CustomModal>
  );
};

export default BookAServiceInfoModal;
